import { Button } from 'antd';
import React from 'react';
import './PrimaryButton.scss';

type Props = {
  label?: string;
  icon?: any;
  htmlType?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  style?: any;
  color?: 'primary-color' | 'secondary-color';
  className?: string;
  target?: string;
  href?: string;
  disabled?: boolean;
  onClick?: () => void;
};

const PrimaryButton: React.FC<Props> = ({
  label,
  icon,
  htmlType,
  loading,
  style,
  color,
  className,
  target,
  href,
  disabled,
  onClick,
  ...props
}) => {
  return (
    <Button
      type="primary"
      className={`btn-primary ${color} ${className}`}
      htmlType={htmlType}
      loading={loading}
      style={style}
      onClick={onClick}
      target={target}
      href={href}
      disabled={disabled}
      {...props}
    >
      {label}
      {icon}
    </Button>
  );
};

export default PrimaryButton;
